import { render, staticRenderFns } from "./TechnicalWrapper.vue?vue&type=template&id=ab4f6c14"
import script from "./TechnicalWrapper.vue?vue&type=script&lang=js"
export * from "./TechnicalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports